import type { PaginationMetadata, PaginationQuery } from "./common";
import type { SalePaymentMethod } from "./sale";

export const RIDER_PAYROLL_STATUSES = [
  "draft",
  "paid",
  "cancelled",
] as const;

export type RiderPayrollStatus = (typeof RIDER_PAYROLL_STATUSES)[number];

export const RIDER_PAYROLL_PAYMENT_METHODS = [
  "cash",
  "edc",
  "qris",
  "app_qris",
  "bank_transfer",
] as const;

export type RiderPayrollPaymentMethod =
  (typeof RIDER_PAYROLL_PAYMENT_METHODS)[number];

export const PAYROLL_ADJUSTMENT_TYPES = ["income", "deduction"] as const;

export type PayrollAdjustmentType = (typeof PAYROLL_ADJUSTMENT_TYPES)[number];

export interface PayrollAdjustment {
  type: PayrollAdjustmentType;
  label: string;
  amount: number;
}

export interface RiderPayroll {
  id: string;
  workspaceId: string;
  riderId: string;
  riderName: string;
  transactionCode: string | null;
  periodStart: string;
  periodEnd: string;
  paymentDate: string | null;
  paymentMethod: RiderPayrollPaymentMethod;
  dailyWageRate: number;
  daysWorked: number;
  salesIncomeAmount: number;
  bonusAmount: number;
  adjustments: PayrollAdjustment[];
  grossIncome: number;
  totalDeductions: number;
  netAmount: number;
  status: RiderPayrollStatus;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRiderPayrollReq {
  riderId: string;
  transactionCode?: string;
  /** rider_sales rows to pick into this payroll — periodStart/End is derived from their dates. */
  riderSaleIds: string[];
  paymentMethod?: RiderPayrollPaymentMethod;
  adjustments?: PayrollAdjustment[];
  notes?: string;
}

export interface UpdateRiderPayrollReq {
  /** Full replacement of the linked rider_sales set, when provided. */
  riderSaleIds?: string[];
  paymentMethod?: RiderPayrollPaymentMethod;
  adjustments?: PayrollAdjustment[];
  notes?: string;
}

export interface MarkRiderPayrollPaidReq {
  paymentDate: string;
}

export interface GetRiderPayrollReq {
  riderId?: string;
  status?: RiderPayrollStatus;
  dateFrom?: string;
  dateTo?: string;
  pagination?: PaginationQuery;
}

export interface RiderPayrollList {
  items: RiderPayroll[];
  pagination: PaginationMetadata;
}
